export const camelToTitle = (str) => {
    let result = str.replace(/([A-Z])/g, " $1");
    result = result.replace("Of", "of");
    result = result.replace("office", "Office");
    result = result.replace("I D", "ID");
    return result.charAt(0).toUpperCase() + result.slice(1);
};

export const date = (ctDate) => {
    return ctDate ? new Date(ctDate) : new Date();
};

export const formattedDateTime = (timeDiff, ctDate) => {
    let uDate = ctDate ? date(date(ctDate) - timeDiff) : date(date() - timeDiff);
    return `${uDate.getFullYear()}-${("0" + (uDate.getMonth() + 1)).slice(-2)}-${("0" + uDate.getDate()).slice(-2)}T${("0" + uDate.getHours()).slice(-2)}:${("0" + uDate.getMinutes()).slice(-2)}:${("0" + uDate.getSeconds()).slice(-2)}`;
};

export const formattedDate = (timeDiff, ctDate, reverse = true) => {
    let uDate = ctDate ? date(date(ctDate) - timeDiff) : date(date() - timeDiff);
    if (reverse) {
        return `${uDate.getFullYear()}-${("0" + (uDate.getMonth() + 1)).slice(-2)}-${("0" + uDate.getDate()).slice(-2)}`;
    } else {
        return `${("0" + uDate.getDate()).slice(-2)}-${("0" + (uDate.getMonth() + 1)).slice(-2)}-${uDate.getFullYear()}`;
    }
};

export const generateColumnClass = (columns = {}) => {
    const columnSizes = ['sm', 'md', 'lg', 'xl', 'xxl'];
    return columnSizes.reduce((classString, size) => {
        return classString + (columns[size] ? ` col-${size}-${columns[size]}` : '');
    }, '');
};

export const formatAddress = (address) => {
    const {street, city, state, zipCode, country} = address;
    // Build the parts array, excluding any empty strings
    const parts = [street, city, state, zipCode, country].filter(part => part && part.trim() !== '');
    // Join the parts with commas and return
    return parts.join(', ');
}
export const isAtLeast15YearsOld = (dateOfBirth, today) => {
    const currentDate = new Date(today);
    const dob = new Date(dateOfBirth);

    // Calculate the difference in years
    let age = currentDate.getFullYear() - dob.getFullYear();

    // Adjust age if current date is before the birthday in the current year
    if (currentDate.getMonth() < dob.getMonth() ||
        (currentDate.getMonth() === dob.getMonth() && currentDate.getDate() < dob.getDate())) {
        age--;
    }
    return age >= 15;
}

export const diffTime = (from, To) => {
    from = new Date(from);
    To = new Date(To);
    return Math.abs(To - from);
};

export const msToDays = (time) => {
    return Math.ceil(time / (1000 * 60 * 60 * 24));
};

export const msToHours = (ms) => {
    return ms / (1000 * 60 * 60);
}

export const capitalize = (str) => {
    if (!str) return ""; // Handle cases where str is null or undefined
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};


export const merge = (a, b) => {
    const merged = {};
    for (const key in a) {
        if (a.hasOwnProperty(key)) {
            merged[key] = a[key];
        }
    }
    for (const key in b) {
        if (b.hasOwnProperty(key)) {
            merged[key] = b[key];
        }
    }
    return merged;
};

export const mergeProperties = (base, data) => {
    const merged = {...base};
    for (const key in data) {
        if (data[key] === null || data[key] === undefined) {
            // Skip null or undefined values in data
            continue;
        }
        if (typeof data[key] === 'object' && !Array.isArray(data[key])) {
            // If the property is an object, recursively merge
            if (base[key] === undefined) {
                // If the base doesn't have this key, assign the data value directly
                merged[key] = data[key];
            } else {
                // Recursively merge nested objects
                merged[key] = mergeProperties(base[key], data[key]);
            }
        } else if (base.hasOwnProperty(key)) {
            // Assign the value directly if it's not an object
            merged[key] = data[key];
        }
    }
    return merged;
};

export const fillProperties = (base, data) => {
    const merged = {...base};
    for (const key in data) {
        if (base.hasOwnProperty(key)) {
            merged[key] = data[key];
        }
    }
    return merged;
}

export const msToHrs = (milliseconds, showSecs = false, showMins = true) => {
    const seconds = Math.floor(milliseconds / 1000) % 60;
    const minutes = Math.floor(milliseconds / (1000 * 60)) % 60;
    const hours = Math.floor(milliseconds / (1000 * 60 * 60));

    const formattedHours = hours < 10 ? `0${hours}` : `${hours}`;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;

    return `${formattedHours}${showMins ? `:${formattedMinutes}` : ''}${showSecs ? `:${formattedSeconds}` : ''}`;
};

export const hrsToMs = (t) => {
    let hrs = Number(t.split(':')[0]) * 60 * 60 * 1000;
    let mins = Number(t.split(':')[1]) * 60 * 1000;
    let secs = Number(t.split(':').length === 3 ? t.split(':')[2] * 1000 : 0);
    return hrs + mins + secs;
};

export const weekToDates = (cd, w, range) => {
    let y = date(cd).getFullYear();
    let d = (1 + (w - 1) * 7); // 1st of January + 7 days for each week
    let dates = [];
    if (range) {
        dates[0] = formattedDate(null, new Date(y, 0, d));
        dates[1] = formattedDate(null, new Date(y, 0, d + 6));
    } else {
        for (let i = 0; i < 7; i++) {
            let date = formattedDate(null, new Date(y, 0, d + i));
            dates.push(date);
        }
    }
    return dates;
};

export const percentage = (value, total) => {
    return value / total * 100 + "%"
};

const getWeek = (dateObj) => {
    const firstJan = new Date(dateObj.getFullYear(), 0, 1);
    const today = new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate());
    const dayOfYear = ((today - firstJan + 86400000) / 86400000);
    return Math.ceil(dayOfYear / 7);
};

export const getCurrentWeek = (ctDate) => {
    return getWeek(new Date(ctDate));
};


export const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

// Helper to get start and end of month in UTC
export const getMonthRange = (year, month, tzOffset = "+05:30") => {
    const [offsetHours, offsetMinutes] = tzOffset.split(":").map(Number);
    const offsetInMinutes = offsetHours * 60 + offsetMinutes;

    // Start of month in local time
    const start = new Date(year, month, 2, 0, 0, 0);
    // End of month in local time
    const end = new Date(year, month + 1, 0, 23, 59, 59, 999);

    // Subtract offset in minutes to get correct ISO string in UTC
    start.setMinutes(start.getMinutes() - offsetInMinutes);
    end.setMinutes(end.getMinutes() - offsetInMinutes);

    return {
        start: start.toISOString(),
        end: end.toISOString(),
    };
};


// Helper to recursively remove empty string values
export const removeEmptyStrings = obj =>
    Object.fromEntries(
        Object.entries(obj)
            .map(([key, value]) => [
                key,
                value && typeof value === 'object'
                    ? removeEmptyStrings(value)
                    : value
            ])
            .filter(([_, value]) => value !== "")
    );


//
// export const getUserRating = (userId, item) => {
//      const currentUserRating = Object.values(item.bookRating).find(item => item.userId === userId);
//      return currentUserRating?.userRating;
// };
//

export const getUserRating = (userId, item) => {
    if (!item?.bookRating || typeof item.bookRating !== 'object') {
        return 0;
    }
    const currentUserRating = Object.values(item.bookRating).find(rating => rating.userId === userId);
    return currentUserRating?.userRating || 0; // Handle cases where no match is found
};

export const getAverageRating = (bootRatings) => {
    const ratings = Object.values(bootRatings);
    // Check if there are any ratings, return 0 if none
    if (ratings.length === 0) return 0;
    // Calculate total using reduce and handle cases where userRating may be undefined or null
    const total = ratings.reduce((sum, {userRating = 0}) => sum + userRating, 0);
    return total / ratings.length;
};


export const encodeImageToBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.onload = () => {
        callback(reader.result); // This is the Base64 string
    };
    reader.onerror = (error) => {
        console.error("Error reading file:", error);
    };
    reader.readAsDataURL(file);
}


export const transformEnumObject = (originalObject) => {
    const transformedObject = {};

    for (const key in originalObject) {
        // Capitalize the first letter and lowercase the rest of the string for the key
        const transformedKey = originalObject[key];
        transformedObject[transformedKey] = originalObject[key];
    }

    return transformedObject;
}

// Create a reverse mapping of enum for lookup
export const reverseEnum = ((Enum) => {
    return Object.entries(Enum).reduce((acc, [key, value]) => {
        acc[value] = key;
        return acc;
    }, {});
});


export const flattenUsers = ((usersObj) => {
    return Object.entries(usersObj).flatMap(([role, users]) =>
        users.map(user => ({
            ...user,
            role
        }))
    );
});

export const appendNested = (formData, data, prefix = '') => {
    Object.entries(data).forEach(([key, value]) => {
        const fullKey = prefix ? `${prefix}[${key}]` : key;

        if (value instanceof File) {
            formData.append(fullKey, value);
        } else if (Array.isArray(value) && value[0] instanceof File) {
            if (value.length === 0) {
                formData.append(fullKey, new Blob(), ''); // append empty file
            } else {
                value.forEach(file => formData.append(fullKey, file));
            }
        } else if (typeof value === 'object' && !(value instanceof File) && value !== null) {
            appendNested(formData, value, fullKey);
        } else {
            // Ensures null/undefined/empty string is appended as empty value
            formData.append(fullKey, value ?? '');
        }
    });
};

export const getValidatedLimit = ({results, totalPages, currentPage}) => {
    const allowedLimits = [10, 25, 50, 100];

    const rawLimit = totalPages && results
        ? Math.floor(results / totalPages)
        : 25;

    let finalLimit = 25; // Default

    if (rawLimit > 0) {
        if (rawLimit > 100) {
            finalLimit = 100;
        } else {
            for (let i = 0; i < allowedLimits.length; i++) {
                if (rawLimit <= allowedLimits[i]) {
                    finalLimit = allowedLimits[i];
                    break;
                }
            }
        }
    }

    return {
        currentPage: currentPage ?? 1,
        limit: finalLimit,
    };
};

export const filterPresets = {
    customerOrderFilter: ["paymentStatus", "startDate", "endDate"],
    allFilter: ["serviceType", "paymentType", "paymentStatus", "orderStatus", "startDate", "endDate"]
};

export const getColumnClasses = (visibleFilters) => {
    if (visibleFilters === filterPresets.allFilter) {
        return {
            leftCol: "col-xl-10",
            rightCol: "col-xl-2"
        };
    } else {
        return {
            leftCol: "col-xl-8",
            rightCol: "col-xl-4"
        };
    }
};

export const toCamelCase = (text) => {
    if (!text) return '';
    return text
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (_, chr) => chr.toUpperCase());
}

export const fromCamelCaseToTitle = (text) => {
    if (!text) return '';
    return text
        .replace(/([a-z])([A-Z])/g, '$1 $2') // space between lower-Upper
        .replace(/^./, char => char.toUpperCase()); // capitalize first letter
}

export const speakAssist = (text) => {
    if (!("speechSynthesis" in window)) {
        console.warn("Speech synthesis not supported in this browser.");
        return;
    }

    const speak = () => {
        const utterance = new SpeechSynthesisUtterance(text);
        utterance.lang = "en-US";
        utterance.rate = 1;
        utterance.pitch = 1;

        // Reset queue (avoid stuck voices)
        window.speechSynthesis.cancel();

        const voices = window.speechSynthesis.getVoices();
        const selectedVoice = voices.find(voice => voice.lang === "en-US");
        if (selectedVoice) utterance.voice = selectedVoice;
        window.speechSynthesis.speak(utterance);
    };

    // Ensure voices are ready
    if (window.speechSynthesis.getVoices().length === 0) {
        window.speechSynthesis.onvoiceschanged = () => speak();
    } else {
        speak();
    }
};

export const getPrimaryBank = (bankList = []) => {
    return bankList.find(bank => bank.primary === true) || null;
};

export const getLatestInvoiceNumber = (list = []) => {
    if (!list.length) return null;

    return list.reduce((latest, current) =>
        new Date(current.date) > new Date(latest.date) ? current : latest
    );
};

export const numberToWords = (num) => {
    if (num === 0) return "Zero Rupees Only";

    const ones = [
        "", "One", "Two", "Three", "Four", "Five", "Six",
        "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
        "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
    ];
    const tens = [
        "", "", "Twenty", "Thirty", "Forty", "Fifty",
        "Sixty", "Seventy", "Eighty", "Ninety"
    ];

    function twoDigits(n) {
        if (n < 20) return ones[n];
        return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    }

    function threeDigits(n) {
        let str = "";
        if (n > 99) {
            str += ones[Math.floor(n / 100)] + " Hundred";
            if (n % 100) str += " "; // remove "and"
        }
        str += twoDigits(n % 100);
        return str.trim();
    }

    const intPart = Math.floor(num);
    const decimalPart = Math.round((num - intPart) * 100);

    let result = "";
    let crore = Math.floor(intPart / 10000000);
    let lakh = Math.floor((intPart % 10000000) / 100000);
    let thousand = Math.floor((intPart % 100000) / 1000);
    let hundred = intPart % 1000;

    if (crore) result += threeDigits(crore) + " Crore ";
    if (lakh) result += threeDigits(lakh) + " Lakh ";
    if (thousand) result += threeDigits(thousand) + " Thousand ";
    if (hundred) result += threeDigits(hundred);

    result = result.trim() || "Zero";

    // Add Rupees
    result = result + " Rupees";

    // Include paise if > 0
    if (decimalPart > 0) {
        result += ` and ${twoDigits(decimalPart)} Paise`;
    }

    result += " Only";

    return result.charAt(0).toUpperCase() + result.slice(1); // Capitalize first letter
};


export const getBaseUrl = () => {
    return window.location.origin;
}

export const isVendorRoute = () => window.location.pathname.startsWith("/vendor-dashboard");

export const logoBase64 = "data:image/png;base64,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"
